// @ts-strict-ignore
import { useSelector } from 'react-redux';
import { RootStoreState } from 'mytours-read-common';
import { AppBannerContent } from './AppBannerContent';
import { AppBannerSkeleton } from './AppBannerSkeleton';
import './appBanner.less';

export function AppBannerContainer({ close, visible }: { close: () => void, visible: boolean }) {
	const appMetaData = useSelector((state: RootStoreState) => state.settings.appMetaData);
	const language = useSelector((state: RootStoreState) => state.settings.selectedLanguage);
	return appMetaData ? <AppBannerContent close={close} visible={visible} appMetaData={appMetaData} language={language} /> : <AppBannerSkeleton visible={visible} />;
};
